import { eBranches } from "sb-helpers";
import { TeamTennisScoreParser } from "./TeamTennisScoreParser";
export class TeamScoreParser {
    constructor() { }
    static get instance() {
        if (!TeamScoreParser._instance) {
            TeamScoreParser._instance = new TeamScoreParser();
        }
        return TeamScoreParser._instance;
    }
    parse(sportEvent, existingEvent) {
        if (Number(existingEvent.sportID) === eBranches.Tennis) {
            return TeamTennisScoreParser.instance.parse(sportEvent, existingEvent.isTeamSwapEnabled);
        }
        return this.defaultParse(sportEvent, existingEvent.isTeamSwapEnabled);
    }
    defaultParse(sportEvent, isTeamSwapEnabled) {
        if (!sportEvent.score) {
            return { Home: undefined, Away: undefined };
        }
        return isTeamSwapEnabled
            ? { Home: sportEvent.score.awayScore, Away: sportEvent.score.homeScore }
            : { Home: sportEvent.score.homeScore, Away: sportEvent.score.awayScore };
    }
}
;
//# sourceMappingURL=TeamScoreParser.js.map